import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "label", "to", "className", "onClick", "aria-label", "ariaLabel"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { navigate, Link } from 'gatsby';
import _get from 'lodash/get';
import { arePathsEqual, getInternalLinkProps } from './InternalLink.utils';
import { withEvent } from '../../modules/analytics/components/Event';
import { isPageTransitionEnabled, PageTransitionController } from '../../modules/animations/components/PageTransition/PageTransition.utils';
import { ChildrenPropType } from '../../services/proptypes';
var defaultProps = {
  label: '',
  className: '',
  children: null,
  onClick: null,
  'aria-label': '',
  ariaLabel: ''
};
function InternalLink(_ref) {
  var children = _ref.children,
    label = _ref.label,
    to = _ref.to,
    className = _ref.className,
    onClickProp = _ref.onClick,
    ariaLabelDom = _ref['aria-label'],
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerProps = getInternalLinkProps(_objectSpread({
    to: to,
    className: className,
    label: label,
    ariaLabel: ariaLabelDom || ariaLabel
  }, rest));
  function onClick(_x, _x2) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, target) {
      var currentPathname, controller;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            if (onClickProp) {
              onClickProp(event, target);
            }
            if (!to) {
              _context.next = 10;
              break;
            }
            currentPathname = _get(window, 'location.pathname', '');
            if (!(isPageTransitionEnabled() && !arePathsEqual(currentPathname, to))) {
              _context.next = 8;
              break;
            }
            controller = new PageTransitionController();
            _context.next = 8;
            return controller.pageOut();
          case 8:
            _context.next = 10;
            return navigate(to);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({}, containerProps, {
    onClick: onClick
  }), children || label);
}
InternalLink.defaultProps = defaultProps;
export default withEvent('click')(InternalLink);